import React from "react";

import "./login-page.m.css";
import { SvgHandler } from "../svg-handler/svg-handler";
import closeIcon from "../../../assets/icons/social/close.svg";

class EditProfile extends React.Component {
  constructor(props) {
    super(props);
    this.defaultStruct = {
      value: "",
      isValid: true
    };
    this.state = {
      name: "",
      email: this.defaultStruct,
      mob: this.defaultStruct
    };

    this.handleValues = this.handleValues.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  handleValues(e, value) {
    const regexMapper = {
      email: RegExp(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/),
      mob: RegExp(/[0-9]+$/)
    };
    const isValid = regexMapper[value].test(e.target.value);
    this.setState({ [value]: { value: e.target.value, isValid } });
  }

  onClear(e, value) {
    e.preventDefault();
    this.setState({ [value]: this.defaultStruct });
  }

  handleSubmit() {
    const { mob, email } = this.state;
    const isValid = mob.isValid && email.isValid;
    if (isValid) {
      // make api call
    }
  }

  render() {
    return (
      <div styleName="container-wrapper">
        <div styleName="heading">Edit Profile</div>
        <div>
          <div styleName="contain-wrapper">
            <div styleName="first-row">
              <div styleName="field-wrapper">
                <label>Name</label>
                <input
                  styleName="field-input"
                  type="text"
                  required
                  value={this.state.name.value}
                  onChange={e => this.handleValues(e, "name")}
                />
                <span styleName="close-btn" onClick={e => this.onClear(e, "name")}>
                  <SvgHandler xlinkHref={closeIcon} />
                </span>
              </div>
              <div styleName="field-wrapper">
                <label>Email</label>
                <input
                  styleName={`field-input ${!this.state.email.isValid ? "error-msg" : ""}`}
                  type="email"
                  required
                  value={this.state.email.value}
                  onChange={e => this.handleValues(e, "email")}
                />
                <span styleName="close-btn" onClick={e => this.onClear(e, "email")}>
                  <SvgHandler xlinkHref={closeIcon} />
                </span>
              </div>
            </div>
            <div styleName="field-wrapper">
              <label>Phone</label>
              <input
                styleName={`field-input ${!this.state.mob.isValid ? "error-msg" : ""}`}
                type="tel"
                maxLength="15"
                required
                value={this.state.mob.value}
                onChange={e => this.handleValues(e, "mob")}
              />
              <span styleName="close-btn" onClick={e => this.onClear(e, "mob")}>
                <SvgHandler xlinkHref={closeIcon} />
              </span>
            </div>
          </div>
          <button styleName="submit-btn" onClick={() => this.handleSubmit()}>
            Submit
          </button>
        </div>
      </div>
    );
  }
}

export { EditProfile };
